<app-loader *ngIf="loaderIcon | async"></app-loader>
<form [formGroup]="loginForm">
  <div class="login-container">
    <div class="left-panel"></div>

    <div class="right-panel">
      <div class="login-card text-start">
        <img src="/assets/images/Logo.webp" class="logo">
        <h5 class="mt-3">{{companyName}}</h5>

        <div class="row mt-5">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
            <span class="error-message" *ngIf="loginError">
              <p i18n>Email address / Password is incorrect!</p>
            </span>
            <span class="error-message" *ngIf="inActive">
              <p i18n>User is Inactive!</p>
            </span>
          </div>
        </div>
        
        <div class="form-group d-flex flex-column align-items-start">
          <div class="d-flex align-items-center w-100">
            <span class="input-group-text" style="top: 11px;">
              <i class="bi bi-person-fill" [style.color]="isFocusedUserId ? 'orange' : '#595C5F'"></i>
            </span>
            <input type="text" class="form-control" placeholder="Email" (focus)="isFocusedUserId = true"
              (blur)="isFocusedUserId = false" formControlName="username" (keyup)="validateLoginCredentials()" required>
          </div>

          <div *ngIf="displayUsernameError" class="error-message mt-1 w-100">
            <ng-container i18n>Email address is required.</ng-container>
          </div>
          <div
            *ngIf="loginForm.get('username').invalid && (loginForm.get('username').dirty || loginForm.get('username').touched)">
            <div *ngIf="loginForm.get('username').errors.email" class="error-message mt-1 w-100">
              <ng-container i18n>Invalid email format.</ng-container>
            </div>
          </div>
        </div>

        <div class="form-group">
          <span class="input-group-text" style="top: 9px;">
            <i class="bi bi-lock-fill" [style.color]="isFocusedPassword ? 'orange' : '#595C5F'"></i>
          </span>
          <input type="password" class="form-control" placeholder="Password" (focus)="isFocusedPassword = true"
            (blur)="isFocusedPassword = false" formControlName="password" (keyup)="validateLoginCredentials()" required>
          <div *ngIf="displayPasswordError" class="error-message"><ng-container i18n>
              Password is required.</ng-container>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mb-2 pl-4">
            <a href="" (click)="forgotPassword($event)" i18n>Forgot your Password?</a>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center mt-2">
            <button class="btn btn-orange text-white" style="min-width: 140px" (click)="validateLogin()">LOGIN</button>
          </div>
        </div>
      </div>
      <div class="login-terms text-white">
  By logging in and accessing the AntiqueSoft Cloud application, the user agrees to the
  <a class="text-white" [routerLink]="['/license-terms']">Software Licensing Terms and Conditions.</a>
</div>

    </div>
  </div>
</form>

<app-resetpassword *ngIf="showPasswordResetModal" [userId]="userId"
  [currentPassword]="this.loginForm.get('password').value" (closeResetModal)="closeResetModal()">
</app-resetpassword>
